import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { getAccountInitials } from "@syla/shared/types/models/AccountAccessBase";
import React from "react";
import { AnimatedChevronIcon } from "../../AnimatedChevronIcon";
import { OptionContentProps } from "../../selector/parts/OptionItem";
import { AccountTypeBadgeColorMap } from "./AccountTypeBadgeColorMap";
import { SelectAccountOption } from "./SelectAccount";

export function SelectAccountOptionContent({
  option,
}: OptionContentProps<SelectAccountOption>): React.ReactElement {
  const account = option.data.account;

  return (
    <>
      <Flex
        flexShrink={0}
        h="2.4rem"
        w="2.4rem"
        rounded="md"
        align="center"
        justify="center"
        backgroundColor="gray.100"
        gap={2}
        borderWidth="1px"
        borderColor="gray.300"
        _groupHover={{ bg: "gray.200" }}
      >
        <Text fontSize="xs" fontWeight="bold">
          {getAccountInitials({ fullName: account.fullName })}
        </Text>
      </Flex>

      <Box minW={0} alignItems="flex-start" flexGrow={1}>
        {account.fullName && (
          <Text width="full" fontWeight="normal" fontSize="md" noOfLines={1}>
            {account.fullName}
          </Text>
        )}

        {account.nickname && (
          <Text
            width="full"
            fontSize="xs"
            fontWeight="light"
            color="gray.600"
            noOfLines={1}
          >
            {account.nickname}
          </Text>
        )}
      </Box>

      <Badge
        flexShrink={0}
        colorScheme={AccountTypeBadgeColorMap[account.accountType]}
      >
        {account.accountType}
      </Badge>

      <AnimatedChevronIcon />
    </>
  );
}
